import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import '../../../../assets/css/screens/serviceprovider/dashboard/kyc/KYC.css';

import STATUS_CFG from '../../../../components/serviceprovider/workerdashboard/workerkyc/statusconfig/StatusConfig';
import KYCHeader from '../../../../components/serviceprovider/workerdashboard/workerkyc/kycheader/KycHeader';
import KYCUploadSection from '../../../../components/serviceprovider/workerdashboard/workerkyc/kycuploadsection/KycUploadSection';
import KYCPendingSection from '../../../../components/serviceprovider/workerdashboard/workerkyc/kycpendingsection/KycPendingSection';
import KYCApprovedSection from '../../../../components/serviceprovider/workerdashboard/workerkyc/kycapprovedsection/KycApprovedSection';

const REVIEW_HOURS = 24;

const WorkerKYC = () => {
  const navigate   = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [kycFile,    setKycFile]    = useState(null);
  const [kycPreview, setKycPreview] = useState('');
  const [kycStatus,  setKycStatus]  = useState('not_submitted');
  const [submitNote, setSubmitNote] = useState('');
  const [loading,    setLoading]    = useState(false);
  const [fetching,   setFetching]   = useState(true);
  const [rejectNote, setRejectNote] = useState('');

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');

    axios.get(`${baseUrl}/worker/viewkyc`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
    .then(res => {
      const kyc = res.data.kyc;

      if (!kyc) {
        setKycStatus('not_submitted');
      } else {
        setKycStatus(kyc.status);
        setRejectNote(kyc.note || '');
      }

      setFetching(false);
    })
    .catch(() => setFetching(false));

  }, []);

  /* ── File handlers ── */
  const handleKycFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setKycFile(file);
    setKycPreview(URL.createObjectURL(file));
  };
  const removeKycFile = () => { setKycFile(null); setKycPreview(''); };

  // upload kyc
  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append('note', submitNote);

    if (kycFile) {
      formData.append('document', kycFile);
    }

    axios.post(`${baseUrl}/worker/submitkyc`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
      }
    })
    .then((response) => {

      console.log(response.data);

      setLoading(false);

      if (response.data.success) {
        setKycStatus('pending');
        setKycFile(null);
        setKycPreview('');
        setSubmitNote('');
      } else {
        alert("Failed to submit KYC");
      }

    })
.catch((err) => {
    setLoading(false);

    console.log(err.response);
    console.log(err.response?.data);

    alert(err.response?.data?.error || "Server Error");
});

  };

  /* ── Format countdown ── */
  const fmtTime = (secs) => {
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const st = STATUS_CFG[kycStatus] || STATUS_CFG.not_submitted;

  if (fetching) {
    return (
      <>
        <WorkerNavbar/>
      </>
    );
  }

  return (
    <>
      <WorkerNavbar/>

      <div className="kyc-page">

        {/* ── Header ── */}
        <KYCHeader />

        <div className="kyc-body">

          {/* ══════════════════════════════════════════
              UPLOAD SECTION — not_submitted or rejected
          ══════════════════════════════════════════ */}
          {(kycStatus === 'not_submitted' || kycStatus === 'rejected') && (
            <KYCUploadSection
              kycStatus={kycStatus}
              rejectNote={rejectNote}
              kycFile={kycFile}
              kycPreview={kycPreview}
              submitNote={submitNote}
              setSubmitNote={setSubmitNote}
              loading={loading}
              handleKycFile={handleKycFile}
              removeKycFile={removeKycFile}
              handleSubmit={handleSubmit}
            />
          )}

          {/* ══════════════════════════════════════════
              PENDING — animated countdown center
          ══════════════════════════════════════════ */}
          {kycStatus === 'pending' && (
            <KYCPendingSection />
          )}

          {/* ══════════════════════════════════════════
              APPROVED
          ══════════════════════════════════════════ */}
          {kycStatus === 'approved' && (
            <KYCApprovedSection />
          )}

        </div>
      </div>
    </>
  );
};

export default WorkerKYC;